export default __webpack_public_path__ + "static/media/(92).881dccde.jpg";